import Marquee from 'react-fast-marquee';
import { Sprout } from 'lucide-react';

const ITEMS = ['NA & RDA APPROVED LAYOUTS', 'LEAD A BETTER FUTURE', 'WITH EMI FACILITY', '100% VAASTU COMPLIANT PLOTS', 'GATED COMMUNITIES', 'YOUR TRUST · OUR COMMITMENT · A BETTER FUTURE'];

export const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="bg-stone border-y border-clay py-5 overflow-hidden">
    <Marquee speed={32} gradient={false}>
      {ITEMS.map((t) => (
        <span key={t} className="flex items-center gap-8 mx-8">
          <span className="font-serif italic text-xl sm:text-2xl text-moss/80 whitespace-nowrap">{t}</span>
          <Sprout size={16} className="text-terra" />
        </span>
      ))}
    </Marquee>
  </div>
);
